import {OrderAdvice} from "../../place-order-wizard/models/OrderAdvice";
import {ChildOrder} from "../../place-order-wizard/models/ChildOrder";
import {OrderLifetime, OrderNumber, OrderSide} from "../../../../../orders/models/OrderRecord";
import {QuoteViewModel} from "../../../../../quote/models/QuoteViewModel";
import {Exchange} from "../../../../../instruments/exchange/Exchange";
import {AccountBriefRecord} from "../../../../../account/types/AccountBriefRecord";
import {PricingInstruction} from "../../../../../orders/models/PricingInstruction";
import {PriceStrategy} from "../../../../../components/inputs/price/input/PriceStrategy";

export interface EquityWizardData {
    readonly orderNumber?: OrderNumber;
    readonly code?: string;
    readonly name?: string;
    readonly exchange?: Exchange;
    readonly side: OrderSide;
    readonly quantity: number;
    readonly limit?: number;
    readonly lifetime: OrderLifetime;
    readonly expiry?: Date;
    readonly pricingInstruction: PricingInstruction;
    readonly type: EquityOrderType;
    readonly totalValue: number;
    readonly portfolio?: AccountBriefRecord;
    readonly advice?: OrderAdvice;
    readonly quote?: QuoteViewModel;
    readonly strategy?: PriceStrategy;
    readonly isStopLoss: boolean;
    readonly stopLossLimit?: number | null;
    readonly isParentOrder: boolean | null;
    readonly childOrders: Array<ChildOrder>;
}

export enum EquityOrderType {
    QUANTITY = "QUANTITY",
    TOTAL_VALUE = "TOTAL_VALUE"
}

export function isSameWizardData(a: EquityWizardData, b: EquityWizardData): boolean {
    if (a === b) {
        return true;
    } else {
        return (a.code === b.code) &&
            (a.name === b.name) &&
            (a.side === b.side) &&
            (a.quantity === b.quantity) &&
            (a.limit === b.limit) &&
            (a.pricingInstruction === b.pricingInstruction) &&
            (a.lifetime === b.lifetime) &&
            (a.expiry === b.expiry) &&
            (a.type === b.type) &&
            (a.totalValue === b.totalValue) &&
            (a.portfolio === b.portfolio) &&
            (a.advice === b.advice) &&
            (a.quote === b.quote) &&
            (a.isStopLoss === b.isStopLoss) &&
            (a.stopLossLimit === b.stopLossLimit) &&
            (a.isParentOrder === b.isParentOrder) &&
            JSON.stringify(a.childOrders) === JSON.stringify(b.childOrders);
    }
}
